import type { FanResponseDto } from '@api'
import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { deleteChat } from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'
import { chatsService } from '@/modules/chatting/service/chats.ts'
import { handleError } from '@/utils/error'

export function useToggleBlockUser() {
  const creatorId = useUnit($creatorId)

  const toast = useToast()

  const blockUserMutation = useMutation(
    (userId: FanResponseDto['id']) =>
      chatsService.blockChat({ creatorId: creatorId!, userId }),
    {
      onSuccess: (data, userId) => {
        toast.success('Successfully blocked user')
        deleteChat(userId)
      },
      onError: (error) => {
        handleError(
          error,
          'Unexpected error occurred while blocking user, please try again later',
        )
      },
    },
  )

  const unblockUserMutation = useMutation(
    (userId: FanResponseDto['id']) =>
      chatsService.unblockChat({ creatorId: creatorId!, userId }),
    {
      onSuccess: () => {
        toast.success('Successfully unblocked user')
      },
      onError: (error) => {
        handleError(
          error,
          'Unexpected error occurred while unblocking user, please try again later',
        )
      },
    },
  )

  return {
    blockUser: blockUserMutation.mutateAsync,
    unblockUser: unblockUserMutation.mutateAsync,
    isBlockUserLoading: blockUserMutation.isLoading,
    isUnblockUserLoading: unblockUserMutation.isLoading,
  }
}
